import { UserRoleChangeService } from './../components/user-role-change/user-role-change.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { GET_USER_ROLES } from 'src/app/shared/constants/user-api-constants';
import {
  DASHBOARD_URL,
  UN_AUTHORIZED_URL,
} from './../../shared/constants/constant';
import {
  GET_ACCESSLEVELS,
  GET_CATEGORY,
  GET_USER_DETAILS_GUID,
} from './../../shared/constants/master-api-constants';
import { Dropdown } from './../../shared/models/dropdown.model';
import {
  UserDetail,
  UserDetails,
} from './../../shared/models/userDetail.model';
import { ApiService } from './api.service';
import {
  ADMIN_MENUS,
  CONSUMER_MENUS,
  REPORTING_EXPORT_MENUS,
  ENDORSER_WORKFLOW_MENUS,
  WORKFLOW_CP_QP_USER_MENUS,
  WORKFLOW_MENUS,
  ORC_WORKFLOW_MENUS,
  CP_QP_ORC_WORKFLOW_MENUS,
  WORKFLOW_DOCUMENTS_MENUS,
} from './main-naviagations';
import { AuthService } from './auth.service';
import { MasterService } from '../../shared/service/master.service';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  reportingCycleCode!: string;

  private userDetails: any;
  private userRoles: any;
  private dropdowns: Dropdown[] = [];
  private accessLevelDropdowns: Dropdown[] = [];
  public isAdmin = false;
  public isCPQP = false;
  public isConsumer = false;
  public menus: Menus[] = [];
  public updateReportingYearHeader = new Subject();
  public updateReportingYear = new Subject();

  constructor(
    private authService: AuthService,
    private router: Router,
    private userRoleChangeService: UserRoleChangeService,
    private masterService: MasterService,
  ) {}

  /**
   * @userDetails
   * @def used to set logged in used details
   */
  public setLoggedInUserDetails(userDetails: UserDetails & UserDetail): void {
    userDetails.displayName = `${userDetails.firstName} ${userDetails.lastName}`;
    this.userDetails = userDetails;

    this.checkForUserRoles();
  }

  /**
   * @def If user don't have any roles then redirect to unauthorized page
   */
  public checkForUserRoles(url?: any): void {
    if (!this.authService.getUserRoles()) {
      this.router.navigateByUrl(UN_AUTHORIZED_URL);
    }

    if (url && this.menus && this.menus.length) {
      let redirectToDashboard = true;
      const isDashboardIndex =
        url.indexOf(`/${DASHBOARD_URL}`) > -1 ? true : false;
      for (const menu of this.menus) {
        const urlIndex = menu.subMenus.findIndex(
          (x) => url.indexOf(x.url) > -1,
        );
        if (urlIndex > -1) {
          redirectToDashboard = false;
          break;
        }
      }
      if (redirectToDashboard && !isDashboardIndex) {
        this.router.navigateByUrl(DASHBOARD_URL);
      }
    }
  }

  /**
   * @def used to get logged in used details
   */
  public getLoggedInUserDetails(): UserDetail & UserDetails {
    return this.userDetails;
  }

  /**
   * getLoggedInID
   */
  public getLoggedInID(): number {
    return this.userDetails.loginID;
  }

  public getHemburgerMenus(): any {
    this.checkForUserRoles();

    this.userRoles = this.authService.getUserRoles();

    if (this.userRoles && this.userRoles.length) {
      const userRole = this.userRoles[0].toLowerCase();
      if (userRole === 'administrator') {
        this.isAdmin = true;
        this.menus = [
          WORKFLOW_MENUS,
          REPORTING_EXPORT_MENUS,
          WORKFLOW_DOCUMENTS_MENUS,
          ADMIN_MENUS,
        ];
      } else if (userRole === 'workflowuser-cp/qp') {
        this.isCPQP = true;
        this.menus = [WORKFLOW_CP_QP_USER_MENUS, REPORTING_EXPORT_MENUS];
      } else if (userRole === 'workflowuser-cp/qp/orc') {
        this.isCPQP = true;
        this.menus = [CP_QP_ORC_WORKFLOW_MENUS, REPORTING_EXPORT_MENUS];
      } else if (userRole === 'workflowuser-orc') {
        this.menus = [ORC_WORKFLOW_MENUS, REPORTING_EXPORT_MENUS];
      } else if (userRole === 'workflowuser-endorser') {
        this.menus = [ENDORSER_WORKFLOW_MENUS, REPORTING_EXPORT_MENUS];
      } else if (userRole === 'workflowuser-enduser') {
        this.menus = [ENDORSER_WORKFLOW_MENUS, REPORTING_EXPORT_MENUS];
      } else {
        this.isConsumer = true;
        this.menus = [
          CONSUMER_MENUS,
          REPORTING_EXPORT_MENUS,
          WORKFLOW_DOCUMENTS_MENUS,
        ];
      }
    } else {
      return [];
    }
    return this.menus;
  }

  public setAccessLevelDropDownValues(dropdowns: Dropdown[]): void {
    sessionStorage.setItem(GET_ACCESSLEVELS, JSON.stringify(dropdowns));
    this.accessLevelDropdowns = dropdowns;
    setTimeout(() => {
      sessionStorage.setItem(GET_ACCESSLEVELS, null);
    }, 3000);
  }

  getGraphUserRole(role: string): boolean {
    const userRole = this.authService.getUserRoles()[0].toLowerCase();
    if (role === 'Administrator' && userRole !== 'administrator') {
      return true;
    } else if (
      role === 'Workflow User - CP/QP' &&
      userRole !== 'workflowuser-cp/qp'
    ) {
      return true;
    } else if (
      role === 'Workflow User - CP/QP/ORC' &&
      userRole !== 'workflowuser-cp/qp/orc'
    ) {
      return true;
    } else if (
      role === 'Workflow User - ORC' &&
      userRole !== 'workflowuser-orc'
    ) {
      return true;
    } else if (
      role === 'Workflow User - Endorser' &&
      userRole !== 'workflowuser-enduser' &&
      userRole !== 'workflowuser-endorser'
    ) {
      return true;
    } else if (role === 'Auditor' && userRole !== 'auditor') {
      return true;
    } else if (role === 'Consumer' && userRole !== 'consumer') {
      return true;
    }
    return false;
  }

  public setUserRoleValues(roles: string[]): void {
    if (!roles) return;

    if (this.getGraphUserRole(roles[0])) {
      this.userRoleChangeService.showLogoutPop();
    }

    sessionStorage.setItem(GET_USER_ROLES, JSON.stringify(roles));

    setTimeout(() => {
      sessionStorage.setItem(GET_USER_ROLES, null);
    }, 3000);
  }

  public getAccessLevelDropdownValues(): Dropdown[] {
    return this.accessLevelDropdowns;
  }

  public getDropdownValuesByID(id: number): Dropdown[] {
    return (
      this.dropdowns && this.dropdowns.filter((x) => x.dropdownParentID === id)
    );
  }

  public getDropdownValueByID(id: string | number, isAsset?: boolean): string {
    if (id === '-1' || id === -1) {
      return null;
    } else {
      if (this.accessLevelDropdowns.find((x) => x.dropdownID == id)) {
        return this.accessLevelDropdowns.find((x) => x.dropdownID == id)
          .dropdownDesc;
      }
      if (isAsset) {
        id = -1;
        return null;
      }
      return this.dropdowns.find((x) => x.dropdownID == id).dropdownDesc;
    }
  }

  public setDropdownValues(dropdowns: Dropdown[]): void {
    sessionStorage.setItem(GET_CATEGORY, JSON.stringify(dropdowns));
    setTimeout(() => {
      sessionStorage.setItem(GET_CATEGORY, null);
    }, 3000);
    this.dropdowns = dropdowns;
  }

  public getAccessLevels(): Observable<any> {
    if (
      sessionStorage.getItem(GET_ACCESSLEVELS) &&
      sessionStorage.getItem(GET_ACCESSLEVELS) !== 'undefined' &&
      sessionStorage.getItem(GET_ACCESSLEVELS) !== 'null'
    ) {
      return new Observable((observer) => {
        observer.next({
          value: JSON.parse(sessionStorage.getItem(GET_ACCESSLEVELS)),
        });
        observer.complete();
      });
    }
    return this.masterService.getAccessLevels();
  }

  public fetchUserRoles(): Observable<any> {
    // read from cache
    if (
      sessionStorage.getItem(GET_USER_ROLES) &&
      sessionStorage.getItem(GET_USER_ROLES) !== 'undefined' &&
      sessionStorage.getItem(GET_USER_ROLES) !== 'null'
    ) {
      return new Observable((observer) => {
        observer.next({
          value: JSON.parse(sessionStorage.getItem(GET_USER_ROLES)),
        });
        observer.complete();
      });
    }

    return this.masterService.getUserRoles();
  }

  public getAllDropdownValues(): Observable<any> {
    if (
      sessionStorage.getItem(GET_CATEGORY) &&
      sessionStorage.getItem(GET_CATEGORY) !== 'undefined' &&
      sessionStorage.getItem(GET_CATEGORY) !== 'null'
    ) {
      return new Observable((observer) => {
        observer.next({
          value: JSON.parse(sessionStorage.getItem(GET_CATEGORY)),
        });
        observer.complete();
      });
    }

    return this.masterService.getCategory();
  }

  public setUserDetailsGUIDValues(user: UserDetails[]): void {
    user[0].displayName = `${user[0].firstName} ${user[0].lastName}`;
    sessionStorage.setItem(GET_USER_DETAILS_GUID, JSON.stringify(user));
    this.userDetails = user;
  }
}

interface Menus {
  key: string;
  name: string;
  subMenus: SubMenus[];
}

interface SubMenus {
  key: string;
  name: string;
  iconClass: string;
  url: string;
}
